import { render, staticRenderFns } from "./FormSidebar.vue?vue&type=template&id=192eccba&scoped=true&"
import script from "./FormSidebar.vue?vue&type=script&lang=js&"
export * from "./FormSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FormSidebar.vue?vue&type=style&index=0&id=192eccba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192eccba",
  null
  
)

export default component.exports